<h1 class="font-family-din text-center text-4xl font-medium text-white select-none">
  {{ text() }}
</h1>
